// extracted by mini-css-extract-plugin
export default {"ServicePage":"ServicePage_ServicePage__W--vY","relatedTechnologies":"ServicePage_relatedTechnologies__Bft20","title":"ServicePage_title__cxw97","badge":"ServicePage_badge__4wpXu"};